exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton{width:100%;height:100%}.skeleton span{display:block;width:100%;height:100%;background-color:#eee;background-image:-webkit-gradient(linear, left top, right top, from(#eee), color-stop(#f5f5f5), to(#eee));background-image:-webkit-linear-gradient(left, #eee, #f5f5f5, #eee);background-image:-o-linear-gradient(left, #eee, #f5f5f5, #eee);background-image:linear-gradient(90deg, #eee, #f5f5f5, #eee);background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;-webkit-animation:animation 1.2s ease-in-out infinite;animation:animation 1.2s ease-in-out infinite;color:rgba(0,0,0,0);font-size:inherit}@-webkit-keyframes animation{0%{background-position:-200px 0}100%{background-position:calc(200px + 100%) 0}}@keyframes animation{0%{background-position:-200px 0}100%{background-position:calc(200px + 100%) 0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/components/skeleton/style.scss
// module id = 1491
// module chunks = 57